import React, { createContext, useContext, useEffect, useState } from "react";
import UserAuthenticated from "./UserAuthenticated";
import firebase from "firebase";
import Fetch from "../script/Fetch";
import { CircularProgress, Stack } from "@mui/material";
import { useParams } from "react-router-dom-v5-compat";

interface AuthContextType {
    isAuthenticated: boolean;
    login: () => Promise<void>;
    logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const fetchUtenteRistorante = async () => {
        let res = await Fetch.doFetch("/utente/ristorante", {
            method: "GET"
        });
        let data = await res.json();

        return data;
    };

    useEffect(() => {
        const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
            if (!user) {
                setIsLoading(false);
                return;
            }

            let data = await fetchUtenteRistorante();
            let ristoranteIdList = data.utenteWithRistoranteList[0].utenteRistoranteList.map((ristorante: any) => ristorante.ristoranteId);
            UserAuthenticated.getInstance().utenteRistoranteList = data.utenteWithRistoranteList[0].utenteRistoranteList;
            UserAuthenticated.getInstance().ristoranteIdList = ristoranteIdList;
            UserAuthenticated.getInstance().ristoranteList = data.ristoranteList;

            // prefer ristoranteId from URL if present
            const path = window.location.pathname;
            const urlSelected = ristoranteIdList.find((id: string) => path.includes(`/${id}`));
            UserAuthenticated.getInstance().setSelectedRistorante(urlSelected || ristoranteIdList[0]);

            setIsAuthenticated(!!user);
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const login = async () => {
        let data = await fetchUtenteRistorante();
        let ristoranteIdList = data.utenteWithRistoranteList[0].utenteRistoranteList.map((ristorante: any) => ristorante.ristoranteId);
        UserAuthenticated.getInstance().utenteRistoranteList = data.utenteWithRistoranteList[0].utenteRistoranteList;
        UserAuthenticated.getInstance().ristoranteIdList = ristoranteIdList;
        UserAuthenticated.getInstance().ristoranteList = data.ristoranteList;

        // prefer ristoranteId from URL if present
        const path2 = window.location.pathname;
        const urlSelected2 = ristoranteIdList.find((id: string) => path2.includes(`/${id}`));
        UserAuthenticated.getInstance().setSelectedRistorante(urlSelected2 || ristoranteIdList[0]);
        
        setIsAuthenticated(true);
    };

    const logout = () => {
        setIsAuthenticated(false);
    };

    if (isLoading) {
        return (
            <Stack sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <CircularProgress />
            </Stack>
        );
    }

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};